export default "__VITE_ASSET__SICo5Z5I__"